<template>
  <div class="instagram-modal">
    <div class="instagram-modal__img">
      <DefImg
        v-if="result.pictures && result.pictures.popupCollection"
        :result="result.pictures.popupCollection"
      />
      <div v-else-if="result.video">
        <DefVideo v-if="result.video.popupCollection" :result="result.video.popupCollection" />
      </div>
      <DefImg
        v-if="result.animation && result.animation.popupCollection"
        :result="result.animation.popupCollection"
      />
      <InstagramUser :result="result" />
    </div>
    <div class="instagram-modal__products">
      <DefSlider :nav="screenWidth >= 992" :pagination="true" :settings="settings">
        <div
          v-for="item in result.displayProperties.PRODUCTS.items"
          :key="(item.offer && item.offer.id) || item.id"
          class="swiper-slide"
        >
          <InstagramModalProduct :result="item" />
        </div>
      </DefSlider>
      <!--      <div v-else class="instagram-modal__items">-->
      <!--        <InstagramModalProduct-->
      <!--          v-for="item in result.displayProperties.PRODUCTS.items"-->
      <!--          :key="(item.offer && item.offer.id) || item.id"-->
      <!--          :result="item"-->
      <!--        />-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import useScreenWidth from '@use/useScreenWidth';
import InstagramModalProduct from '@components/sliders/InstagramLooks/InstagramModal/InstagramModalProduct.vue';
import InstagramUser from '@components/sliders/InstagramLooks/InstagramModal/InstagramUser.vue';

export default {
  name: 'InstagramModal',
  components: { InstagramUser, InstagramModalProduct, DefSlider, DefVideo, DefImg },
  props: ['result'],
  data() {
    return {
      settings: {},
      screenWidth: useScreenWidth(),
    };
  },
};
</script>

<style lang="scss" scoped>
.instagram-modal {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  @include point-md {
    grid-template-columns: 1fr 328px;
  }
  @include point-lg {
    grid-template-columns: 1fr 412px;
  }
  &__img {
    position: relative;
    :deep(.instagram-user) {
      position: absolute;
      bottom: 16px;
      left: 16px;
      right: 16px;
    }
    :deep(.def-img) {
      width: 100%;
    }
  }
  &__products {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 24px 16px;
    @include point-md {
      padding: 24px;
    }
    @include point-lg {
      padding: 32px 40px;
    }
  }
  //&__items {
  //  display: grid;
  //  grid-row-gap: 16px;
  //}
  :deep(.def-slider__prev) {
    left: 0;
  }
  :deep(.def-slider__next) {
    right: 0;
  }
  :deep(.def-slider__default-button) {
    background-color: transparent;
  }
  :deep(.def-slider__pagination) {
    @include point-md {
      margin-top: 20px;
    }
    @include point-lg {
      margin-top: 32px;
    }
  }
}
</style>
